import { isAlphanumericAllSpecialCharacters, isAlphanumericWithPlusAmpersandEqualsPlusMinus } from "../../../functions/validations";
import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";

const getRowError = (error, type) => {
  const fields = ['ProductForm', 'Spec', 'PNo', 'GNo', 'Thick', 'Diam'];
  const hasError = fields.some(field => error[`WPSH_BM_${type}_${field}`]?.status);
  const errorField = fields.find(field => error[`WPSH_BM_${type}_${field}`]?.message);
  return { 
    hasError, 
    errorMessage: errorField ? error[`WPSH_BM_${type}_${errorField}`]?.message : '' 
  };
};

export const WPS_Base_metals = ({
  headerObj,
  error,
  readOnly,
  handleChange,
  setError,
}) => {
  const columns = [
    { type: 'label', field: "label", width: '150px' },
    { header: 'Product Form', field: 'ProductForm', type: 'input', inputWidth: '152px', maxLength: 15, validator: isAlphanumericWithPlusAmpersandEqualsPlusMinus ,className: "WpsInput-md"},
    { header: 'Spec (Type of Grade)', field: 'Spec', type: 'input', inputWidth: '335px', maxLength: 35, validator: isAlphanumericAllSpecialCharacters ,className: "WpsInput-md"},
    { header: 'P No. / A No.', field: 'PNo', type: 'input', inputWidth: '100px', maxLength: 10, validator: isAlphanumericAllSpecialCharacters,className: "WpsInput-md" },
    { header: 'G. No.', field: 'GNo', type: 'input', maxLength: 5, validator: isAlphanumericAllSpecialCharacters,className: "WpsInput-md" },
    { header: 'Thk.mm', field: 'Thick', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters,className: "WpsInput-md" },
    { header: 'Dia.mm', field: 'Diam', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters ,className: "WpsInput-md"}
  ];

  const tableData = {
    rows: [
      {
        label: { value: 'Base Metal 1' },
        ProductForm: { value: headerObj?.WPSH_BM_BaseMetal1_ProductForm, field: "WPSH_BM_BaseMetal1_ProductForm", error: error["WPSH_BM_BaseMetal1_ProductForm"]?.status || false },
        Spec: { value: headerObj?.WPSH_BM_BaseMetal1_Spec, field: "WPSH_BM_BaseMetal1_Spec", error: error["WPSH_BM_BaseMetal1_Spec"]?.status || false },
        PNo: { value: headerObj?.WPSH_BM_BaseMetal1_PNo, field: "WPSH_BM_BaseMetal1_PNo", error: error["WPSH_BM_BaseMetal1_PNo"]?.status || false },
        GNo: { value: headerObj?.WPSH_BM_BaseMetal1_GNo, field: "WPSH_BM_BaseMetal1_GNo", error: error["WPSH_BM_BaseMetal1_GNo"]?.status || false },
        Thick: { value: headerObj?.WPSH_BM_BaseMetal1_Thick, field: "WPSH_BM_BaseMetal1_Thick", error: error["WPSH_BM_BaseMetal1_Thick"]?.status || false },
        Diam: { value: headerObj?.WPSH_BM_BaseMetal1_Diam, field: "WPSH_BM_BaseMetal1_Diam", error: error["WPSH_BM_BaseMetal1_Diam"]?.status || false },
        ...getRowError(error, "BaseMetal1")
      },
      {
        label: { value: 'Welded To - Base Metal 2' },
        ProductForm: { value: headerObj?.WPSH_BM_WeldBaseMetal2_ProductForm, field: "WPSH_BM_WeldBaseMetal2_ProductForm", error: error["WPSH_BM_WeldBaseMetal2_ProductForm"]?.status || false },
        Spec: { value: headerObj?.WPSH_BM_WeldBaseMetal2_Spec, field: "WPSH_BM_WeldBaseMetal2_Spec", error: error["WPSH_BM_WeldBaseMetal2_Spec"]?.status || false },
        PNo: { value: headerObj?.WPSH_BM_WeldBaseMetal2_PNo, field: "WPSH_BM_WeldBaseMetal2_PNo", error: error["WPSH_BM_WeldBaseMetal2_PNo"]?.status || false },
        GNo: { value: headerObj?.WPSH_BM_WeldBaseMetal2_GNo, field: "WPSH_BM_WeldBaseMetal2_GNo", error: error["WPSH_BM_WeldBaseMetal2_GNo"]?.status || false },
        Thick: { value: headerObj?.WPSH_BM_WeldBaseMetal2_Thick, field: "WPSH_BM_WeldBaseMetal2_Thick", error: error["WPSH_BM_WeldBaseMetal2_Thick"]?.status || false },
        Diam: { value: headerObj?.WPSH_BM_WeldBaseMetal2_Diam, field: "WPSH_BM_WeldBaseMetal2_Diam", error: error["WPSH_BM_WeldBaseMetal2_Diam"]?.status || false },
        ...getRowError(error, "WeldBaseMetal2")
      }
    ]
  };

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={readOnly}
      handleChange={handleChange}
      setError={setError}
      disableFields={readOnly}
    />
  );
};
